import { useMutation } from '@apollo/client';

import { MAKE_CUSTOMER_PRESENT_CARD_PAYMENT, UPDATE_CUSTOMER } from 'store/mutations';
import { getSptmConfig } from 'utils/sptm';
import takeCardPaymentCompletionHandler from './takeCardPaymentCompletionHandler';
import createTakeCardPaymentErrorHandler from './createTakeCardPaymentErrorHandler';
import { CP_PAYMENT_STATUS_SUCCESS } from '../../../constants/customerPresent';
import printReceiptMutation from './mutations/printReceiptMutation';

const useCustomerPresentMutation = ({ customer, reference, currency, history, setAlert, passengers, isExchange, isFlowForwardCapped }) => {
  const [printReceipt, { loading: loadingPrintReceipt }] = useMutation(printReceiptMutation);
  const [updateCustomer] = useMutation(UPDATE_CUSTOMER);

  const [makeCustomerPresentCardPayment, { loading: loadingMakePayment }] = useMutation(MAKE_CUSTOMER_PRESENT_CARD_PAYMENT, {
    onCompleted: takeCardPaymentCompletionHandler({
      reference,
      customer,
      currency,
      printReceipt,
      setAlert,
      passengers,
      isExchange,
      updateCustomer
    }),
    onError: createTakeCardPaymentErrorHandler({
      booking: {
        customer,
        reference,
        currency
      },
      actions: {
        setAlert,
        printReceipt
      }
    }),
    refetchQueries: ['booking']
  });

  // we'll just keep this one here as it might be needed after testing's done
  // todo: check in which case we'd need this to throw
  // if (error) {
  //   throw new AgentPortalError(error)
  // }

  const mutation = async (amountToPay, totalPriceToBePaid) => {
    const { TERMINAL_ID, TERMINAL_SERIAL_NO } = await getSptmConfig();

    const amount = parseFloat(amountToPay);
    const balanceLeft = parseFloat(totalPriceToBePaid);

    const isFullAmount = amount === balanceLeft;

    const takeCardResponse = await makeCustomerPresentCardPayment({
      variables: {
        bookingReference: reference,
        amount,
        currency,
        terminalId: TERMINAL_ID,
        cashRegisterId: TERMINAL_SERIAL_NO,
        isSplitPayment: !isFullAmount,
        isFlowForwardCapped
      }
    });

    if (!takeCardResponse || takeCardResponse.data.makeCustomerPresentCardPayment.receipt.paymentStatus !== CP_PAYMENT_STATUS_SUCCESS) {
      return;
    }

    if (isFullAmount) {
      history.push(`/manage/bookings/${reference}/journeys`);
    }
  };

  const loading = loadingPrintReceipt || loadingMakePayment;

  return [mutation, { loading }];
};

export default useCustomerPresentMutation;
